import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import { orgLinkPrefix } from "healthex-common/utils";
import { Outlet } from "react-router";
import { getObservableT } from "../Infra/i18next";
import { AIAssistantView } from "./AIAssistantView";
import { AcceptInviteView } from "./AcceptInviteView";
import { AccountSettingsAboutYourOrgView } from "./AccountSettingsAboutYourOrgView";
import { AccountSettingsLoginAndSecurityView } from "./AccountSettingsLoginAndSecurityView";
import { AccountSettingsProfileView } from "./AccountSettingsProfileView";
import { AccountSettingsView } from "./AccountSettingsView";
import { AddPatientsView } from "./AddPatient/AddPatientsView";
import { AddProjectView } from "./AddProject/AddProjectView";
import { AdminAPIKeysListView } from "./AdminAPIKeysListView";
import { AdminDataPolicyView } from "./AdminDataPolicyView";
import { AdminDataSettingsView } from "./AdminDataSettingsView";
import { AdminOrganizationSettingsView } from "./AdminOrganizationSettingsView";
import { AdminPatientSettingsView } from "./AdminPatientSettingsView";
import { AdminResearchSettingsView } from "./AdminResearchSettingsView";
import { AdminUserListView } from "./AdminUserListView";
import { AdminView } from "./AdminView";
import { AppView } from "./AppView";
import { ClearIAL2LoginView } from "./ClearIAL2LoginView";
import { DesignSystemDemoView } from "./DesignSystemDemoView";
import { ExpiredPasswordView } from "./ExpiredPasswordView";
import { ForgotPasswordView } from "./ForgotPasswordView";
import { HealthcareOrganizationAnalyticsView } from "./HealthcareOrganizationAnalyticsView";
import { InformedConsentExperienceView } from "./InformedConsentExperienceView";
import { LoginFlowView } from "./LoginFlowView";
import { NamedRoutes } from "./NamedRoutes";
import { PatientConsentManagerView } from "./PatientConsentManagerView";
import { PatientDetailsHealthcareOrgView } from "./PatientDetailsHealthcareOrgView";
import { PatientMyHealthExView } from "./PatientMyHealthExView";
import { PatientProfileView } from "./PatientProfileView";
import { PatientResearchStudyDetailsView } from "./PatientResearchStudyDetailsView";
import { PatientStudiesListView } from "./PatientStudiesListView";
import { PatientSwitchOrganizationView } from "./PatientSwitchOrganizationView";
import { PatientsSearchView } from "./PatientsSearchView";
import { PatientsView } from "./PatientsView";
import { RecruitmentView } from "./RecruitmentView";
import { RedirectToPatientPortalEmbedView } from "./RedirectToPatientPortalEmbedView";
import { ResearchView } from "./ResearchView";
import { ResearcherStudiesDetailView } from "./ResearcherStudiesDetailView";
import { ResetPasswordView } from "./ResetPasswordView";
import { SiteStudyDetailsView } from "./SiteStudyDetailsView";
import { SmartAuthProgressView } from "./SmartAuthProgressView";
import { StudiesOverviewView } from "./StudiesOverviewView";
import { StudyManagerView } from "./StudyManagerView";
import { WelcomeBackOrgUserView } from "./WelcomeBackOrgUserView";
import { WelcomeBasicOrgDetailsView } from "./WelcomeBasicOrgDetailsView";
import { WelcomeCustomizeOrgDetailsView } from "./WelcomeCustomizeOrgDetailsView";
import { WelcomeOrgUserInviteView } from "./WelcomeOrgUserInviteView";
import { WelcomeUserDetailsView } from "./WelcomeUserDetailsView";
import { WelcomeUserView } from "./WelcomeUserView";
import { GlobalAdminAgentReleaseEditView } from "./global-admin/GlobalAdminAgentReleaseEditView";
import { GlobalAdminAgentReleasesListView } from "./global-admin/GlobalAdminAgentReleasesListView";
import { GlobalAdminJobManagementView } from "./global-admin/GlobalAdminJobManagementView";
import { GlobalAdminQueueDetailView } from "./global-admin/GlobalAdminQueueDetailView";
import { GlobalAdminGlobalOrganizationListView } from "./global-admin/GlobalAdminGlobalOrganizationsListView";
import { GlobalAdminMedAlliesView } from "./global-admin/GlobalAdminMedAlliesView";
import { GlobalAdminHealthcareOrganizationLoginSettingsView } from "./global-admin/GlobalAdminHealthcareOrganizationLoginSettingsView";
import { GlobalAdminManageOrganizationView } from "./global-admin/GlobalAdminManageOrganizationView";
import { GlobalAdminManageUserView } from "./global-admin/GlobalAdminManageUserView";
import { GlobalAdminNewOrganizationView } from "./global-admin/GlobalAdminNewOrganizationView";
import { GlobalAdminUsersView } from "./global-admin/GlobalAdminUsersView";
import { GlobalAdminView } from "./global-admin/GlobalAdminView";
import { GlobalAdminOrgDetailView } from "./global-admin/GlobalAdminOrgDetailView";
import { FacilitatedFHIRLoginView } from "./FacilitatedFHIRLoginView";
import { FastenCallbackView } from "./FastenCallbackView";
import { PatientDeleteMyAccountView } from "./PatientDeleteMyAccountView";
import { PatientDeleteMyAccountConfirmationView } from "./PatientDeleteMyAccountConfirmationView";
import { PatientLogoutView } from "./PatientLogoutView";
import { RouteErrorView } from "./RouteErrorView";
import { SocialLoginCallbackView } from "./SocialLoginCallbackView";
const t = getObservableT("common");
export function routingPaths(container) {
    return [
        {
            route: NamedRoutes.INDEX,
            path: "/",
            element: _jsx(AppView, { container: container }),
            errorElement: _jsx(RouteErrorView, { container: container }),
            children: [
                {
                    route: NamedRoutes.USER_INVITE,
                    path: "user-invite/:inviteContractAddress/:inviteSecret",
                    title: t("Accept Invite"),
                    element: _jsx(AcceptInviteView, { container: container }),
                },
                {
                    route: NamedRoutes.FORGOT_PASSWORD,
                    path: "forgot-password",
                    title: t("Forgot Password"),
                    element: _jsx(ForgotPasswordView, { container: container }),
                },
                {
                    route: NamedRoutes.EXPIRED_PASSWORD,
                    path: "expired-password/:userEmailAddress",
                    title: t("Expired Password"),
                    element: _jsx(ExpiredPasswordView, { container: container }),
                },
                {
                    route: NamedRoutes.RESET_PASSWORD,
                    path: "reset-password/:resetPasswordToken",
                    element: _jsx(ResetPasswordView, { container: container }),
                },
                {
                    route: NamedRoutes.DESIGN_SYSTEM_DEMO,
                    path: "design-system-demo",
                    element: _jsx(DesignSystemDemoView, {}),
                },
                {
                    route: NamedRoutes.ACCOUNT_SETTINGS,
                    path: "account-settings",
                    title: t("Account Settings"),
                    element: _jsx(AccountSettingsView, { container: container }),
                    children: [
                        {
                            route: NamedRoutes.ACCOUNT_SETTINGS_PROFILE,
                            path: "profile",
                            title: t("Account Profile"),
                            element: _jsx(AccountSettingsProfileView, { container: container }),
                        },
                        {
                            route: NamedRoutes.ACCOUNT_SETTINGS_LOGIN_AND_SECURITY,
                            path: "login-and-security",
                            title: t("Account Login And Security"),
                            element: _jsx(AccountSettingsLoginAndSecurityView, { container: container }),
                        },
                        {
                            route: NamedRoutes.ACCOUNT_SETTINGS_ABOUT_YOUR_ORG,
                            path: "about-your-org",
                            title: t("Account About Your Organization"),
                            element: _jsx(AccountSettingsAboutYourOrgView, { container: container }),
                        },
                    ],
                },
                {
                    route: NamedRoutes.HEALTHCARE_ORG_ANALYTICS,
                    path: "healthcare-organization-analytics",
                    title: t("Analytics"),
                    element: _jsx(HealthcareOrganizationAnalyticsView, { container: container }),
                },
                {
                    route: NamedRoutes.PROJECTS,
                    path: "projects",
                    children: [
                        {
                            index: true,
                            indexForRoute: NamedRoutes.PROJECTS,
                            title: t("Projects"),
                            element: _jsx(ResearchView, { container: container }),
                        },
                        {
                            route: NamedRoutes.MY_PROJECTS,
                            path: "my-projects",
                            title: t("My Projects"),
                            element: _jsx(ResearchView, { container: container }),
                        },
                        {
                            route: NamedRoutes.OTHER_PROJECTS,
                            path: "other-projects",
                            title: t("Other Projects"),
                            element: _jsx(ResearchView, { container: container }),
                        },
                        {
                            route: NamedRoutes.PROJECTS_ADD_PROJECT,
                            path: ":projectId/add-project/:page?",
                            title: t("Add Project"),
                            element: _jsx(AddProjectView, { container: container }),
                        },
                        {
                            route: NamedRoutes.PROJECTS_ADD_PATIENTS_METHOD,
                            path: ":projectId/add-patients/:method?",
                            title: t("Add Patients"),
                            element: _jsx(AddPatientsView, { container: container }),
                        },
                        {
                            route: NamedRoutes.PROJECTS_PROJECT_MANAGER,
                            path: ":projectId",
                            element: _jsx(StudyManagerView, { container: container }),
                            children: [
                                {
                                    route: NamedRoutes.PROJECTS_PROJECT_MANAGER_ANALYTICS,
                                    path: "analytics",
                                    title: t("Project Analytics"),
                                    element: _jsx(StudiesOverviewView, { container: container }),
                                },
                                {
                                    route: NamedRoutes.PROJECTS_PROJECT_MANAGER_PATIENT_MANAGEMENT,
                                    path: "patient-management/:filter?",
                                    title: t("Project Patient Management"),
                                    element: _jsx(RecruitmentView, { container: container }),
                                },
                                {
                                    route: NamedRoutes.PROJECTS_PROJECT_MANAGER_DETAILS,
                                    path: "details",
                                    title: t("Project Details"),
                                    element: _jsx(ResearcherStudiesDetailView, { container: container }),
                                },
                                {
                                    route: NamedRoutes.PROJECTS_PROJECT_MANAGER_PATIENT_EXPERIENCE,
                                    path: "patients-experience",
                                    title: t("Project Patient Experience"),
                                    element: _jsx(InformedConsentExperienceView, { container: container }),
                                },
                            ],
                        },
                        {
                            route: NamedRoutes.PROJECTS_OTHER_DETAILS,
                            path: ":projectId/other-details",
                            title: t("Project Details"),
                            element: _jsx(SiteStudyDetailsView, { container: container }),
                        },
                    ],
                },
                {
                    route: NamedRoutes.PATIENTS,
                    path: "patients",
                    title: t("Patients"),
                    element: _jsx(Outlet, {}),
                    children: [
                        {
                            index: true,
                            indexForRoute: NamedRoutes.PATIENTS,
                            title: t("Patients"),
                            element: _jsx(PatientsView, { container: container }),
                        },
                        {
                            route: NamedRoutes.PATIENTS_SEARCH,
                            path: "search/:mrn",
                            title: t("Patients search"),
                            element: _jsx(PatientsSearchView, { container: container }),
                        },
                        {
                            route: NamedRoutes.PATIENTS_STUDY_DETAILS,
                            path: "patient-study-details/:studyId/:mrn",
                            title: t("Patient study details"),
                            element: _jsx(PatientDetailsHealthcareOrgView, { container: container }),
                        },
                    ],
                },
                {
                    route: NamedRoutes.PATIENT_MY_HEALTHEX,
                    path: "patient-my-healthex",
                    children: [
                        {
                            index: true,
                            indexForRoute: NamedRoutes.PATIENT_MY_HEALTHEX,
                            title: t("Patient My HealthEx"),
                            element: _jsx(PatientMyHealthExView, { container: container }),
                        },
                        {
                            route: NamedRoutes.PATIENT_MY_HEALTHEX_PROFILE,
                            path: "profile",
                            title: t("Patient Profile"),
                            element: _jsx(PatientProfileView, { container: container }),
                        },
                        {
                            route: NamedRoutes.PATIENT_DELETE_MY_ACCOUNT,
                            path: "delete-my-account",
                            title: t("Delete My Account"),
                            element: _jsx(PatientDeleteMyAccountView, { container: container }),
                        },
                    ],
                },
                {
                    route: NamedRoutes.PATIENT_SHARING,
                    path: "patient-sharing/:section?",
                    title: t("Patient Sharing"),
                    element: _jsx(PatientStudiesListView, { container: container }),
                },
                {
                    route: NamedRoutes.PATIENT_SHARING_DETAILS,
                    path: "patient-sharing-details/:studyId",
                    title: t("Patient Sharing Details"),
                    element: _jsx(PatientResearchStudyDetailsView, { container: container }),
                },
                {
                    route: NamedRoutes.ADMIN,
                    path: "admin",
                    element: _jsx(AdminView, { container: container }),
                    children: [
                        {
                            route: NamedRoutes.ADMIN_ORG_SETTINGS,
                            path: "org-settings/:section?",
                            title: t("Admin"),
                            element: _jsx(AdminOrganizationSettingsView, { container: container }),
                        },
                        {
                            route: NamedRoutes.ADMIN_USERS,
                            path: "users",
                            element: _jsx(AdminUserListView, { container: container }),
                        },
                        {
                            route: NamedRoutes.ADMIN_APIKEYS,
                            path: "api-keys",
                            element: _jsx(Outlet, {}),
                            children: [
                                {
                                    index: true,
                                    indexForRoute: NamedRoutes.ADMIN_APIKEYS,
                                    title: `${t("Admin")} | ${t("Manage API Keys")}`,
                                    element: _jsx(AdminAPIKeysListView, { container: container }),
                                },
                            ],
                        },
                        {
                            route: NamedRoutes.ADMIN_DATA_SETTINGS,
                            path: "data-settings/:section?",
                            title: `${t("Admin")} | ${t("Data Settings")}`,
                            element: _jsx(AdminDataSettingsView, { container: container }),
                        },
                        {
                            route: NamedRoutes.ADMIN_DATA_POLICY,
                            path: "data-policy/:dataSourceId?",
                            title: `${t("Admin")} | ${t("Data Policy")}`,
                            element: _jsx(AdminDataPolicyView, { container: container }),
                            children: [
                                {
                                    route: NamedRoutes.ADMIN_DATA_POLICY_DATA_CLASSIFICATION,
                                    path: "data-classification",
                                    title: t("Data Classification"),
                                    element: _jsx(AdminDataPolicyView, { container: container }),
                                },
                                {
                                    route: NamedRoutes.ADMIN_DATA_POLICY_DATA_ENFORCEMENT,
                                    path: "data-enforcement",
                                    title: t("Data Enforcement"),
                                    element: _jsx(AdminDataPolicyView, { container: container }),
                                },
                            ],
                        },
                        {
                            route: NamedRoutes.ADMIN_RESEARCH_SETTINGS,
                            path: "research-settings/:section?",
                            title: `${t("Admin")} | ${t("Research Settings")}`,
                            element: _jsx(AdminResearchSettingsView, { container: container }),
                        },
                        {
                            route: NamedRoutes.ADMIN_PATIENT_SETTINGS,
                            path: "patient-settings/:section?",
                            title: `${t("Admin")} | ${t("Patient Settings")}`,
                            element: _jsx(AdminPatientSettingsView, { container: container }),
                        },
                    ],
                },
                {
                    route: NamedRoutes.GLOBAL_ADMIN,
                    path: "global-admin",
                    element: _jsx(GlobalAdminView, { container: container }),
                    children: [
                        {
                            route: NamedRoutes.GLOBAL_ADMIN_ORGANIZATIONS,
                            path: "organizations",
                            element: _jsx(Outlet, {}),
                            children: [
                                {
                                    index: true,
                                    indexForRoute: NamedRoutes.GLOBAL_ADMIN_ORGANIZATIONS,
                                    title: `${t("Global Admin")} | ${t("Organizations")}`,
                                    element: _jsx(GlobalAdminGlobalOrganizationListView, { container: container }),
                                },
                                {
                                    route: NamedRoutes.GLOBAL_ADMIN_ORG_DATA_ORIGINATOR_CREATE,
                                    path: "data-originator/create",
                                    title: `${t("Global Admin")} | ${t("Create Healthcare Organization")}`,
                                    element: _jsx(GlobalAdminNewOrganizationView, { container: container }),
                                },
                                {
                                    route: NamedRoutes.GLOBAL_ADMIN_ORG_DATA_ORIGINATOR_DETAIL,
                                    path: "data-originator/:orgId",
                                    element: _jsx(GlobalAdminOrgDetailView, { container: container }),
                                    children: [
                                        {
                                            index: true,
                                            indexForRoute: NamedRoutes.GLOBAL_ADMIN_ORG_DATA_ORIGINATOR_DETAIL,
                                            title: `${t("Global Admin")} | ${t("Healthcare Organization Detail")}`,
                                            element: _jsx(GlobalAdminManageOrganizationView, { container: container }),
                                        },
                                        {
                                            route: NamedRoutes.GLOBAL_ADMIN_ORG_DATA_ORIGINATOR_LOGIN_SETTINGS,
                                            path: "login-settings",
                                            title: `${t("Global Admin")} | ${t("Login Settings")}`,
                                            element: _jsx(GlobalAdminHealthcareOrganizationLoginSettingsView, { container: container }),
                                        },
                                        {
                                            route: NamedRoutes.GLOBAL_ADMIN_ORG_DATA_ORIGINATOR_USERS,
                                            path: "users",
                                            element: _jsx(Outlet, {}),
                                            children: [
                                                {
                                                    index: true,
                                                    indexForRoute: NamedRoutes.GLOBAL_ADMIN_ORG_DATA_ORIGINATOR_USERS,
                                                    title: `${t("Global Admin")} | ${t("Manage Healthcare Organization Users")}`,
                                                    element: _jsx(GlobalAdminUsersView, { container: container }),
                                                },
                                                {
                                                    route: NamedRoutes.GLOBAL_ADMIN_ORG_DATA_ORIGINATOR_USER_DETAIL,
                                                    path: ":userId",
                                                    title: `${t("Global Admin")} | ${t("Healthcare Organization User Detail")}`,
                                                    element: _jsx(GlobalAdminManageUserView, { container: container }),
                                                },
                                            ],
                                        },
                                    ],
                                },
                                {
                                    route: NamedRoutes.GLOBAL_ADMIN_ORG_DATA_USER_CREATE,
                                    path: "data-user/create",
                                    title: `${t("Global Admin")} | ${t("Create External Research Organization")}`,
                                    element: _jsx(GlobalAdminNewOrganizationView, { container: container }),
                                },
                                {
                                    route: NamedRoutes.GLOBAL_ADMIN_ORG_DATA_USER_DETAIL,
                                    path: "data-user/:orgId",
                                    element: _jsx(GlobalAdminOrgDetailView, { container: container }),
                                    children: [
                                        {
                                            index: true,
                                            indexForRoute: NamedRoutes.GLOBAL_ADMIN_ORG_DATA_USER_DETAIL,
                                            title: `${t("Global Admin")} | ${t("External Research Organization Detail")}`,
                                            element: _jsx(GlobalAdminManageOrganizationView, { container: container }),
                                        },
                                        {
                                            route: NamedRoutes.GLOBAL_ADMIN_ORG_DATA_USER_USERS,
                                            path: "users",
                                            element: _jsx(Outlet, {}),
                                            children: [
                                                {
                                                    index: true,
                                                    indexForRoute: NamedRoutes.GLOBAL_ADMIN_ORG_DATA_USER_USERS,
                                                    title: `${t("Global Admin")} | ${t("Manage External Research Organization Users")}`,
                                                    element: _jsx(GlobalAdminUsersView, { container: container }),
                                                },
                                                {
                                                    route: NamedRoutes.GLOBAL_ADMIN_ORG_DATA_USER_USER_DETAIL,
                                                    path: ":userId",
                                                    title: `${t("Global Admin")} | ${t("External Research User Detail")}`,
                                                    element: _jsx(GlobalAdminManageUserView, { container: container }),
                                                },
                                            ],
                                        },
                                    ],
                                },
                                {
                                    route: NamedRoutes.GLOBAL_ADMIN_ORG_SERVICE_PROVIDER_DETAIL,
                                    path: "service-provider/:orgId",
                                    element: _jsx(GlobalAdminOrgDetailView, { container: container }),
                                    children: [
                                        {
                                            index: true,
                                            indexForRoute: NamedRoutes.GLOBAL_ADMIN_ORG_SERVICE_PROVIDER_DETAIL,
                                            title: `${t("Global Admin")} | ${t("Service Provider Organization Detail")}`,
                                            element: _jsx(GlobalAdminManageOrganizationView, { container: container }),
                                        },
                                        {
                                            route: NamedRoutes.GLOBAL_ADMIN_ORG_SERVICE_PROVIDER_USERS,
                                            path: "users",
                                            element: _jsx(Outlet, {}),
                                            children: [
                                                {
                                                    index: true,
                                                    indexForRoute: NamedRoutes.GLOBAL_ADMIN_ORG_SERVICE_PROVIDER_USERS,
                                                    title: `${t("Global Admin")} | ${t("Manage Service Provider Users")}`,
                                                    element: _jsx(GlobalAdminUsersView, { container: container }),
                                                },
                                                {
                                                    route: NamedRoutes.GLOBAL_ADMIN_ORG_SERVICE_PROVIDER_USER_DETAIL,
                                                    path: ":userId",
                                                    title: `${t("Global Admin")} | ${t("Service Provider User Detail")}`,
                                                    element: _jsx(GlobalAdminManageUserView, { container: container }),
                                                },
                                            ],
                                        },
                                    ],
                                },
                            ],
                        },
                        {
                            route: NamedRoutes.GLOBAL_ADMIN_AGENT_RELEASES,
                            path: "agent-releases",
                            element: _jsx(Outlet, {}),
                            children: [
                                {
                                    index: true,
                                    indexForRoute: NamedRoutes.GLOBAL_ADMIN_AGENT_RELEASES,
                                    title: `${t("Global Admin")} | ${t("Agent Releases")}`,
                                    element: _jsx(GlobalAdminAgentReleasesListView, { container: container }),
                                },
                                {
                                    route: NamedRoutes.GLOBAL_ADMIN_AGENT_RELEASE_EDIT,
                                    path: "edit/:id",
                                    title: `${t("Global Admin")} | ${t("Agent Release Edit")}`,
                                    element: _jsx(GlobalAdminAgentReleaseEditView, { container: container }),
                                },
                                {
                                    route: NamedRoutes.GLOBAL_ADMIN_AGENT_RELEASE_NEW,
                                    path: "new",
                                    title: `${t("Global Admin")} | ${t("Agent Release Edit")}`,
                                    element: _jsx(GlobalAdminAgentReleaseEditView, { container: container }),
                                },
                            ],
                        },
                        {
                            route: NamedRoutes.GLOBAL_ADMIN_MEDALLIES,
                            path: "medallies",
                            title: `${t("Global Admin")} | ${t("MedAllies")}`,
                            element: _jsx(GlobalAdminMedAlliesView, { container: container }),
                        },
                        {
                            route: NamedRoutes.GLOBAL_ADMIN_JOB_MANAGEMENT,
                            path: "jobs",
                            element: _jsx(Outlet, {}),
                            children: [
                                {
                                    index: true,
                                    indexForRoute: NamedRoutes.GLOBAL_ADMIN_JOB_MANAGEMENT,
                                    title: `${t("Global Admin")} | ${t("Job Management")}`,
                                    element: _jsx(GlobalAdminJobManagementView, { container: container }),
                                },
                                {
                                    route: NamedRoutes.GLOBAL_ADMIN_QUEUE_DETAIL,
                                    path: ":queueName",
                                    title: `${t("Global Admin")} | ${t("Queue Detail")}`,
                                    element: _jsx(GlobalAdminQueueDetailView, { container: container }),
                                },
                            ],
                        },
                    ],
                },
                {
                    route: NamedRoutes.LOGIN_SELECT,
                    path: "login-select/*",
                    element: _jsx(LoginFlowView, { container: container }),
                },
                {
                    route: NamedRoutes.LOGIN_AS_ORG_USER,
                    path: "login/*",
                    element: _jsx(LoginFlowView, { container: container }),
                },
                {
                    route: NamedRoutes.LOGIN_AS_PATIENT,
                    path: "login-patients/*",
                    element: _jsx(LoginFlowView, { container: container }),
                },
                {
                    route: NamedRoutes.LOGIN_SWITCH_ORG_AS_PATIENT,
                    path: "login-switch",
                    element: _jsx(PatientSwitchOrganizationView, { container: container }),
                },
                {
                    route: NamedRoutes.LOGIN_REDIRECT_TO_EMBED,
                    path: "redirect-to-embed/:organizationId",
                    element: _jsx(RedirectToPatientPortalEmbedView, { container: container }),
                },
                {
                    route: NamedRoutes.PATIENT_ACCOUNT_DELETE_CONFIRMATION,
                    path: "patient-account-delete-confirmation",
                    title: t("Patient Account Delete Confirmation"),
                    element: _jsx(PatientDeleteMyAccountConfirmationView, { container: container }),
                },
                {
                    route: NamedRoutes.PATIENT_CONSENT_ENROLLMENT,
                    path: "patient-consent/:studyId/enrollment/:step?/:link?",
                    title: t("Patient Consent Enrollment"),
                    element: _jsx(PatientConsentManagerView, { container: container }),
                },
                {
                    route: NamedRoutes.PATIENT_CONSENT_DATA_UPDATE,
                    path: "patient-consent/:studyId/data-update/:step?/:link?",
                    title: t("Patient Consent Data Update"),
                    element: _jsx(PatientConsentManagerView, { container: container }),
                },
                {
                    route: NamedRoutes.PATIENT_IAS_CONSENT,
                    path: "patient-consent/ias/:step?/:link?",
                    title: t("Patient IAS Consent"),
                    element: _jsx(PatientConsentManagerView, { container: container }),
                },
                {
                    route: NamedRoutes.PATIENT_IAS_DATA_UPDATE,
                    path: "patient-consent/ias-update/:step?/:link?",
                    title: t("Patient IAS Data Update"),
                    element: _jsx(PatientConsentManagerView, { container: container }),
                },
                {
                    route: NamedRoutes.PATIENT_IAS_CONSENT,
                    path: "patient-consent/ias/:step?/:link?",
                    title: t("Patient IAS Consent"),
                    element: _jsx(PatientConsentManagerView, { container: container }),
                },
                {
                    route: NamedRoutes.PATIENT_IAS_DATA_UPDATE,
                    path: "patient-consent/ias-update/:step?/:link?",
                    title: t("Patient IAS Data Update"),
                    element: _jsx(PatientConsentManagerView, { container: container }),
                },
                {
                    route: NamedRoutes.PATIENT_IAS_CONSENT,
                    path: "patient-consent/ias/:step?/:link?",
                    title: t("Patient IAS Consent"),
                    element: _jsx(PatientConsentManagerView, { container: container }),
                },
                {
                    route: NamedRoutes.PATIENT_IAS_DATA_UPDATE,
                    path: "patient-consent/ias-update/:step?/:link?",
                    title: t("Patient IAS Data Update"),
                    element: _jsx(PatientConsentManagerView, { container: container }),
                },
                {
                    route: NamedRoutes.GUIDED_PATIENT_CONSENT_ENROLLMENT,
                    path: "guided-patient-consent/:studyId/:mrn/enrollment/:step?/:link?",
                    title: t("Guided Patient Consent Enrollment"),
                    element: _jsx(PatientConsentManagerView, { container: container }),
                },
                {
                    route: NamedRoutes.AI_ASSISTANT,
                    path: "ai-assistant",
                    title: "HealthEx AI",
                    element: _jsx(AIAssistantView, { container: container }),
                },
                {
                    route: NamedRoutes.WELCOME,
                    path: "welcome",
                    children: [
                        {
                            route: NamedRoutes.WELCOME,
                            path: ":welcomeToken",
                            title: t("Getting Started"),
                            element: _jsx(WelcomeUserView, { container: container }),
                        },
                        {
                            route: NamedRoutes.WELCOME_ORG,
                            path: "org/:welcomeOrgId",
                            title: t("Getting Started"),
                            element: _jsx(WelcomeUserView, { container: container }),
                        },
                        {
                            route: NamedRoutes.WELCOME_ORG_USER_DETAILS,
                            path: "user-details",
                            title: t("User details"),
                            element: _jsx(WelcomeUserDetailsView, { container: container }),
                        },
                        {
                            route: NamedRoutes.WELCOME_BASIC_ORG_DETAILS,
                            path: "basic-org-details",
                            title: t("Basic Org Details"),
                            element: _jsx(WelcomeBasicOrgDetailsView, { container: container }),
                        },
                        {
                            route: NamedRoutes.WELCOME_CUSTOMIZE_ORG_DETAILS,
                            path: "customize-org-details",
                            title: t("Customize Org Details"),
                            element: _jsx(WelcomeCustomizeOrgDetailsView, { container: container }),
                        },
                        {
                            route: NamedRoutes.WELCOME_ORG_USER_INVITE,
                            path: "invite-org-users",
                            title: t("Invite Org Users"),
                            element: _jsx(WelcomeOrgUserInviteView, { container: container }),
                        },
                        {
                            route: NamedRoutes.WELCOME_BACK_ORG_USER,
                            path: "welcome-back",
                            title: t("Welcome back"),
                            element: _jsx(WelcomeBackOrgUserView, { container: container }),
                        },
                    ],
                },
                {
                    route: NamedRoutes.SMART_CALLBACK,
                    path: "smart-callback",
                    element: _jsx(SmartAuthProgressView, { container: container }),
                },
                {
                    route: NamedRoutes.SMART_LAUNCH_PROVIDER,
                    path: "smart-launch-provider/:vanitySubdomain",
                    element: _jsx(SmartAuthProgressView, { container: container }),
                },
                {
                    route: NamedRoutes.SMART_LAUNCH,
                    path: "smart-launch/:vanitySubdomain",
                    element: _jsx(SmartAuthProgressView, { container: container }),
                },
                {
                    route: NamedRoutes.ORG_LINK,
                    path: `${orgLinkPrefix}/:organizationId/*`,
                    element: _jsx(_Fragment, {}),
                },
                {
                    route: NamedRoutes.SMART_FULL_LAUNCH,
                    path: `smart-full-launch/:shortLivedToken`,
                    element: _jsx(_Fragment, {}),
                },
                {
                    route: NamedRoutes.CLEAR_IAL2_CALLBACK,
                    path: "clear-ial2-callback",
                    element: _jsx(ClearIAL2LoginView, { container: container }),
                },
                {
                    route: NamedRoutes.FACILITATED_FHIR_CALLBACK,
                    path: "epic-nexus/redirect",
                    element: _jsx(FacilitatedFHIRLoginView, { container: container }),
                },
                {
                    route: NamedRoutes.FASTEN_CALLBACK,
                    path: "fasten-callback",
                    element: _jsx(FastenCallbackView, { container: container }),
                },
                {
                    route: NamedRoutes.SOCIAL_LOGIN_CALLBACK,
                    path: "social-login-callback",
                    element: _jsx(SocialLoginCallbackView, { container: container }),
                },
                {
                    route: NamedRoutes.LOGOUT_AS_PATIENT,
                    path: "logout-patient",
                    element: _jsx(PatientLogoutView, { container: container }),
                },
            ],
        },
    ];
}
